import { countryCodes } from "./countries";
import { languageCodes } from "./languages";

export const countriesLanguages = {
 [countryCodes.UAE]: [languageCodes.EN],
 [countryCodes.GREECE]: [languageCodes.EN, languageCodes.EL],
 [countryCodes.SA]: [languageCodes.EN],
}
